import React from 'react'
import { Tab, Tabs, Typography } from '@telavita-core/react-design-kit'

import { Header } from './styles'

interface ICustomizedHeaderProps {
  activeTab: number
  handleChangeTab: (event: React.ChangeEvent<Element>, id: number) => void
}

export const CustomizedHeader = ({
  activeTab,
  handleChangeTab,
}: ICustomizedHeaderProps): JSX.Element => {
  return (
    <Header>
      <Typography italic variant='content2'>
        Pacientes com direito a agendar:
      </Typography>

      <Tabs
        selectedTab={activeTab}
        onChange={handleChangeTab}
      >
        <Tab label="Semanalmente" id={0} />
        <Tab label="Quinzenalmente" id={1} />
      </Tabs>
    </Header>
  )
}